import React from 'react';
import BillLines from '../BillLines';
import { formatMoney, paidTotal } from '../../../utils/money';

/** Step 5 — manager confirms the payment by name (stamped on the bill). */
export default function ReviewStep({ bill, managerName, onManagerName }) {
  const payments = (bill.payments || []).filter((p) => ['received', 'verified'].includes(p.status));
  return (
    <div className="dp-step-body">
      <div className="dp-step-head">
        <h2>Review</h2>
        <p className="dp-help">The manager checks the payment and confirms it with their name.</p>
      </div>
      <div className="dp-pay-totals">
        <div>
          <span>Total</span>
          <strong>{formatMoney(bill.grand_total)}</strong>
        </div>
        <div>
          <span>Paid</span>
          <strong>{formatMoney(paidTotal(bill))}</strong>
        </div>
        <div>
          <span>Method</span>
          <strong>{payments.map((p) => (p.method === 'cash' ? 'Cash' : 'UPI')).join(' + ') || '—'}</strong>
        </div>
      </div>
      <label className="dp-field">
        <span>Payment confirmed by (manager name)</span>
        <input className="dp-input dp-input--lg" value={managerName} onChange={(e) => onManagerName(e.target.value)} placeholder="Manager name" autoFocus />
      </label>
      <BillLines bill={bill} />
    </div>
  );
}
